import axiosClient from './axiosClient';

const sessionUserApi = {
  create: (data) => {
    const url = '/session-users';
    return axiosClient.post(url, data);
  },
  update: (data, sessionUserId) => {
    const url = `/session-users/${sessionUserId}`;
    return axiosClient.put(url, data);
  },
  delete: (id) => {
    const url = `/session-users/${id}`;
    return axiosClient.delete(url);
  },
  getUsers: (params, sessionId, data) => {
    if (data) {
      const url = `/session-users/${sessionId}/users?updateAll=${data}`;
      return axiosClient.get(url, { params });
    } else {
      const url = `/session-users/${sessionId}/users`;
      return axiosClient.get(url, { params });
    }
  },
  updateAll: (data) => {
    const url = '/session-users/bulk-update';
    return axiosClient.put(url, data);
  },
};

export default sessionUserApi;
